import Input from './ui/InputUi'

export default Input
